export default {
  calculate: (wordString, numberOfImages) => {
    const wordCount = wordString.split(" ").length
    // /Math.ceil(minutes.toFixed(2))
    const AVERAGE_READING_SPEED = 200
    return (
      (wordCount / AVERAGE_READING_SPEED + 0.2 * numberOfImages) *
      60
    ).toFixed(0)
  },
}
